// hooks/useZoom.js
import { useEffect, useState, useCallback } from "react";

export function useZoom(storageKey = "ZOOM", { min = 0.6, max = 1.8, step = 0.1, initial = 1 } = {}) {
    const [zoom, setZoom] = useState(() => {
        const saved = localStorage.getItem(storageKey);
        const val = saved ? Number(saved) : initial;
        return isNaN(val) ? initial : val;
    });

    useEffect(() => {
        localStorage.setItem(storageKey, String(zoom));
    }, [storageKey, zoom]);

    const clamp = useCallback((z) => Math.max(min, Math.min(max, Number(z))), [min, max]);

    const zoomIn = useCallback(() => setZoom((z) => clamp(Math.round((z + step) * 100) / 100)), [clamp, step]);
    const zoomOut = useCallback(() => setZoom((z) => clamp(Math.round((z - step) * 100) / 100)), [clamp, step]);
    const resetZoom = useCallback(() => setZoom(initial), [initial]);
    const set = useCallback((z) => setZoom(clamp(z)), [clamp]);

    return { zoom, zoomIn, zoomOut, resetZoom, setZoom: set, min, max, step };
}
